module.exports = __webpack_public_path__ + "static/media/facebook_reaction_wow.5eac4a3a.svg";